<mat-progress-bar
  *ngIf="isAnimating || !hideOnComplete"
  mode="determinate"
  @fadeOut
  [value]="progress"
></mat-progress-bar>
